var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BrandHeader'),_c('router-view'),(_vm.isShowFooter)?_c('BrandFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }